import { render, staticRenderFns } from "./IngresoProceso.vue?vue&type=template&id=25ba770f"
import script from "./IngresoProceso.vue?vue&type=script&lang=js"
export * from "./IngresoProceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports